<div id="step-signin" class="flex flex-1 min-h-full flex-col">
  <div class="mt-fdk-xxxl">
    <h2 class="fdk-type-heading-2">Connect your health records</h2>
    <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxxs">
      <ng-container *ngIf="!isCspRequestUriSignin; else cspInstructions">
        Create an account with your email address to access your health records
        via Clear.
      </ng-container>
      <ng-template #cspInstructions
        >Press continue to verify your identity.</ng-template
      >
    </p>
  </div>

  <form
    (ngSubmit)="signinSubmit()"
    #vaultProfileForm="ngForm"
    class="mt-fdk-l flex flex-1 flex-col"
  >
    <div>
      <ng-container *ngIf="!isCspRequestUriSignin">
        <fdk-input
          [(ngModel)]="existingVaultProfile.email"
          (ngModelChange)="
            existingVaultProfile.email = $event.toLowerCase().trim()
          "
          name="email"
          #email="ngModel"
          label="Email address"
          placeholder="you@example.com"
          type="email"
          autocomplete="email"
          [list]="
            configService.systemConfig$.apiMode === ApiMode.Test
              ? 'test-identity-emails'
              : null
          "
          [minlength]="4"
          [required]="true"
          email
          [error]="email.invalid && (email.dirty || email.touched)"
          [errorMessage]="
            email.errors?.['required']
              ? 'Email is required.'
              : email.errors?.['minlength']
                ? 'Email must be at least 4 characters long.'
                : email.errors?.['email']
                  ? 'Email must be a valid email address.'
                  : ''
          "
        />

        <datalist
          *ngIf="configService.systemConfig$.apiMode === ApiMode.Test"
          id="test-identity-emails"
        >
          <option
            *ngFor="let testIdentityEmail of testIdentityEmails"
            [value]="testIdentityEmail"
          ></option>
        </datalist>
      </ng-container>
    </div>

    <fdk-alert
      *ngIf="errorMsg"
      class="mt-fdk-m mb-fdk-m"
      variant="error"
      title="We couldn't sign you in."
      [description]="errorMsg"
    />

    <div class="mt-auto">
      <fdk-button
        type="submit"
        variant="primary"
        width="full"
        [disabled]="
          (!isCspRequestUriSignin && !vaultProfileForm.form.valid) || loading
        "
      >
        <span class="flex items-center justify-center gap-2"
          ><fdk-spinner *ngIf="loading" /> Sign in</span
        >
      </fdk-button>
    </div>
  </form>
</div>
